/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BotExamLangTranslationViewModel } from "../types/BotExamLangTranslationViewModel.ts";
import { botExamLangTranslationQuestionViewModelSchema } from "./botExamLangTranslationQuestionViewModelSchema.ts";

export const botExamLangTranslationViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do idioma da prova bot.")),
  botExamLangId: z.optional(
    z
      .number()
      .int()
      .describe("ID do registro de idioma (ClassroomDisciplineBotExamLang)."),
  ),
  botExamId: z.optional(
    z
      .number()
      .int()
      .describe("ID da prova bot principal (ClassroomDisciplineBotExam)."),
  ),
  title: z
    .string()
    .describe("Título da prova bot no idioma alvo. Opcional.")
    .nullish(),
  targetLanguageInfo: z
    .string()
    .describe("Código de cultura do idioma alvo da tradução. Opcional.")
    .nullish(),
  currentPage: z.optional(
    z
      .number()
      .int()
      .describe("Número da página atual da paginação por questão."),
  ),
  totalPages: z.optional(
    z.number().int().describe("Total de páginas disponíveis."),
  ),
  totalCount: z.optional(
    z.number().int().describe("Total de questões da prova bot neste idioma."),
  ),
  pageSize: z.optional(
    z
      .number()
      .int()
      .describe("Quantidade de questões por página (normalmente 1)."),
  ),
  questions: z
    .array(z.lazy(() => botExamLangTranslationQuestionViewModelSchema))
    .describe(
      "Questões da página atual para tradução/revisão. Cada item exibe o par original (pt-BR) e traduzido.",
    )
    .nullish(),
}) as unknown as ToZod<BotExamLangTranslationViewModel>;
